import { gql } from 'graphql-request'

export const GlobalEducationPageQuery = gql`
  query GlobalEducationPage(
    $locale: LocaleInputType!
  ) {
    EducationPage(locale: $locale) {
      title
      subTitle
      description
    }
  }
`
